import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Grid, Header } from 'semantic-ui-react';
import { SemanticToastContainer } from 'react-semantic-toasts';
import PropTypes from 'prop-types';
import { GoogleLogin } from '@react-oauth/google';
import { loginWithGoogle } from 'state/session/actions';
import * as toast from 'state/toast/actions';
import styles from './Login.module.css';

export class LoginPage extends React.Component {
  onGoogleSuccess = credentialResponse => {
    const { dispatch } = this.props;
    dispatch(loginWithGoogle(credentialResponse.credential));
  };

  onGoogleError = () => {
    const { dispatch } = this.props;
    dispatch(
      toast.errorMessage(
        'Login error',
        'Google sign-in failed. Please try again.'
      )
    );
  };

  render() {
    const { isLoggedIn, location } = this.props;
    const previousPath = location.state ? location.state.previousPath : '/';
    if (isLoggedIn) {
      return <Redirect to={previousPath} />;
    }

    return (
      <div className={styles['login-container']}>
        <Grid textAlign="center">
          <Grid.Column width={6}>
            <SemanticToastContainer />
            <Header>Moka Internal Tools</Header>
            <div className={styles['google-login-wrapper']}>
              <GoogleLogin
                onSuccess={this.onGoogleSuccess}
                onError={this.onGoogleError}
              />
            </div>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = ({ session }) => ({
  isLoggedIn: session.currentUser !== null,
});

LoginPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  location: PropTypes.any.isRequired,
};

export default connect(mapStateToProps)(LoginPage);
